import React, { useEffect, useState } from 'react'
import VerificationList from './VerificationList'
import UpdatesAccountList from './UpdatesAccountList'

function AdminPanelRedirect({activePanel}) {
      const [skip, setSkip] = useState(0);
    useEffect(()=>
    {
        setSkip(0);
    }, [activePanel])
    const builder = () => {
        switch(activePanel){
            case 0:
                return <VerificationList />
            case 1:
                return <UpdatesAccountList key="updates"/>
            case 2:
                return <UpdatesAccountList key="org" org="true"/>

            default:
                <></>
        }
    }

  return (
    <>{builder()}</>
  )
}

export default AdminPanelRedirect